import type React from 'react';

/* eslint-disable react/jsx-props-no-spreading */
import { Modal as BaseModal } from '@coop/components';

import { SiteContextProvider, SiteContextType } from '../../contexts/siteContext';
import { ErrorGroup } from '../../store/structureDefinitions/errorsState';
import ErrorGroupNotification from '../molecules/GroupErrorNotifications/ErrorGroupNotification';

type ModalProps = React.ComponentPropsWithoutRef<typeof BaseModal>;

export const Modal = (props: ModalProps) => {
    return (
        <SiteContextProvider siteContext={SiteContextType.Modal}>
            <BaseModal {...props}>
                {props.children}
                <ModalErrorNotification />
            </BaseModal>
        </SiteContextProvider>
    );
};

type FlyInAlignment = 'left' | 'right';

type FlyInSizes = 250 | 375 | 460 | 510 | 540 | 1000;

export interface FlyInProps extends Omit<ModalProps, 'toggleTime'> {
    sizePx?: FlyInSizes;
    alignment?: FlyInAlignment;
    scrollable?: boolean;
}

const ModalErrorNotification = () =>
    ErrorGroupNotification({
        errorGroup: ErrorGroup.Modal,
    });
